import { render, staticRenderFns } from "./ServiceproviderCalendar.vue?vue&type=template&id=5929164f&"
import script from "./ServiceproviderCalendar.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports